export default __webpack_public_path__ + "static/decorist-8-b-1385d662b8da7a59030a13e5342c2698.webp";